import Image from 'next/image';
import styles from './DubaiBanner.module.css';
import { useGlobalContext } from '@/lib/context';
import { LeadPopUpButton } from '@/components/shared/lead/LeadPopUpButton';
import { ElemenetType } from '@/lib/constants';
export function DubaiBanner() {
    const { props: { isMobileView } } = useGlobalContext();
    return (<section>
        <div className={styles.homeBanermbox}>
            {
                !isMobileView ?
                    <div className={styles.bannerImgbox}>
                        <Image width={1349} height={600} className="img-responsive" src="/assets/images/dubai-banner-web.png" alt="Interior Design Company in Dubai" />
                    </div>
                    :
                    <div className={styles.bannerImgboxrepoive}>
                        <Image width={347} height={580} className="img-responsive" src="/assets/images/dubai-banner-mobile.png" alt="Interior Design Company in Dubai" />
                    </div>
            }
            <div className={styles.bannerMnbox}>
                <div className="containerFull">
                    <div className={styles.banTextmin}>
                        <div className={styles.leftTextbox}>
                            <h2>Fine Interiors, Finer Services.</h2>
                            <span>Experience the Perfect Balance of Style and
                                Functionality with the Best Interior Design Company in Dubai.</span>
                        </div>
                        <div className={styles.rightBtbox}>
                            <LeadPopUpButton ElemenetType={ElemenetType.button} ButtonClass={`primaryBtn `}>Book Free Consultation</LeadPopUpButton>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    )
}